/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Message_Body_View_ItemInputs */

const he_notifications_message_body_view_item = /** @type {(inputs: Notifications_Message_Body_View_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צפו במוצר`)
};

const en_notifications_message_body_view_item = /** @type {(inputs: Notifications_Message_Body_View_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View item`)
};

/**
* | output |
* | --- |
* | "View item" |
*
* @param {Notifications_Message_Body_View_ItemInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_message_body_view_item = /** @type {((inputs?: Notifications_Message_Body_View_ItemInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Message_Body_View_ItemInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_message_body_view_item(inputs)
	return en_notifications_message_body_view_item(inputs)
});